import { useCallback, useEffect, useState } from "react";
import { api, getChildId } from "./api";

export const PALETTE = ["#E53935", "#FB8C00", "#FDD835", "#7CB342", "#2E7D32", "#26C6DA", "#1E88E5", "#3949AB", "#8E24AA", "#EC407A", "#F8BBD0", "#8D6E63", "#FFFFFF", "#9E9E9E", "#424242", "#000000"];
export const STICKERS = ["⭐", "❤️", "🌸", "🦋", "🐼", "🏮", "🌙", "🐰", "🐉", "☁️", "🌈", "🍐", "🐘", "🎋", "🧧", "☀️"];

export const FRAME_STYLE = {
  none: { pad: 0, bg: "transparent", colors: [] },
  wood: { pad: 14, bg: "linear-gradient(135deg,#a9743f,#7a4a22 50%,#a9743f)", colors: ["#a9743f", "#7a4a22"] },
  red: { pad: 14, bg: "linear-gradient(135deg,#d63a2a,#9e1f14)", colors: ["#d63a2a", "#9e1f14"], inner: "#e9c46a" },
  gold: { pad: 16, bg: "linear-gradient(135deg,#f7dc7a,#c99a2e 45%,#f7e3a0 70%,#b8862a)", colors: ["#f7dc7a", "#b8862a"] },
  jade: { pad: 14, bg: "linear-gradient(135deg,#5fb89a,#1f6f55)", colors: ["#5fb89a", "#1f6f55"] },
  cloud: { pad: 16, bg: "repeating-radial-gradient(circle at 0 0,#3b82c4 0 6px,#1d6fb8 6px 12px)", colors: ["#3b82c4", "#1d6fb8"] },
  rainbow: { pad: 14, bg: "linear-gradient(135deg,#ef4444,#f59e0b,#facc15,#22c55e,#3b82f6,#a855f7)", colors: ["#ef4444", "#facc15", "#3b82f6", "#a855f7"] },
};

export const WALL_STYLE = {
  cream: { background: "radial-gradient(circle at 20% 10%,#fffaf0,#f6ead2)" },
  brick: { background: "repeating-linear-gradient(0deg,#b5523b 0 34px,#e9d3c3 34px 37px),#b5523b", backgroundBlendMode: "normal" },
  garden: { background: "linear-gradient(#bfe6ff 0 55%,#9ed68a 55% 100%)" },
  night: { background: "radial-gradient(#ffffff 1px,transparent 1.5px) 0 0/38px 38px,radial-gradient(#fde68a 1px,transparent 1.5px) 19px 19px/38px 38px,#1e2a4a" },
  palace: { background: "linear-gradient(#e9b949 0 18px,#8f1d16 18px 100%)" },
};

export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString("zh-TW", { year: "numeric", month: "long", day: "numeric" }) : "");

export const useArt = () => {
  const childId = getChildId();
  const [data, setData] = useState(null);
  const load = useCallback(() => api.get("/art/activities", { params: { child_id: childId } }).then((r) => setData(r.data)), [childId]);
  useEffect(() => { load(); }, [load]);
  return [data, load, childId];
};

export const useWorks = () => {
  const childId = getChildId();
  const [works, setWorks] = useState(null);
  const load = useCallback(() => api.get("/art/works", { params: { child_id: childId } }).then((r) => setWorks(r.data)), [childId]);
  useEffect(() => { load(); }, [load]);
  return [works, load, setWorks, childId];
};

export const patchWork = (id, body) => api.patch(`/art/works/${id}`, body).then((r) => r.data);
